import React, { Component } from 'react';
import './FormGroup.scss';

interface IFormGroup {
  /**
  * The form elements wrapped by this component
  */
 children?: any,
 /**
 * Add custom classes
 */
 className?: string,
 /**
  * add custom inline style
  */
 style?: object,
}

class FormGroup extends Component<IFormGroup, any> {
  render() {
    const { children = null, style = {}, className = "" } = this.props;

    return (
      <div className={`cc-form-group ${className}`} style={style}>
        {children}
      </div>
    );
  }
}

export default FormGroup;
